export const state = () => ({
  type: null,
});

export const mutations = {
  setToolbar(state, payload) {
    state.type = payload;
  },
};

export const actions = {};

export const getters = {
  loadedToolbar(state) {
    return state.type;
  },
};
